import { Injectable } from '@angular/core';
import { ActionCreator, ActionsSubject, DefaultProjectorFn, MemoizedSelector, NotAllowedCheck, Store, Action } from '@ngrx/store';
import { SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';

import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReduxWrapperService extends SafariInjector {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- "hiding"
  private ___store: Store<any>;
  private _dispatcher: ActionsSubject;
  constructor() {
    super();
    this.___store = this.inject(Store);
    this._dispatcher = this.inject(ActionsSubject);
  }

  listenForAction<T extends string, P extends object>(action: ActionCreator<T, (props: P & NotAllowedCheck<P>) => P & Action<T>>): Observable<P & Action<T>>;
  listenForAction<T extends string>(action: ActionCreator<T, () => Action<T>>): Observable<Action<T>>;
  listenForAction(action: Action) {
    return this._dispatcher.pipe(filter(o => o.type == action.type));
  }
  dispatchGenericAction(action: any, async = false): void {
    if (async) {
      setTimeout(() => this.___store.dispatch(action));
    } else {
      this.___store.dispatch(action);
    }
  }
  // I think filterNull is almost always the case but let's wait until we are in the beggining of an iteration before
  // we flip default to true
  getGenericSelector<T>(selector: MemoizedSelector<object, T, DefaultProjectorFn<T>>, filterNull = false): Observable<T> {
    if (filterNull) {
      return this.___store.select(selector).pipe(filter(o => o != null));
    }
    return this.___store.select(selector);
  }
}
